import ReactOnRails from 'react-on-rails';
import DogNames from '../../bundles/DogNames/components/DogNames.client.jsx';

ReactOnRails.register({DogNames});
